<template>
  <div class="preview-viewer preview-wps-edit">
    <iframe ref="wps_edit_frame" v-if="link" :src="link" id="wps_edit_frame" name="wps_edit_frame"></iframe>
  </div>
</template>

<script>

export const WpsState = {
  'SUCCEED': 'SUCCEED',
  'FAILED': 'FAILED'
}

export default {
  name: 'WpsEdit',
  props: {
    previewInfo: Object,
    item: Object,
    url: String
  },
  data () {
    return {
      link: this.url
    }
  },
  created () {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="postcss">
.preview-wps-edit {
  & iframe {
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
